export default function Field_relate_simple_id(item, nameFields) {
	if (!item) {
		return "-";
	}
	if (nameFields.length > 1) {
		let names = [];
		for (let k in nameFields) {
			if (item[nameFields[k]]) {
				names.push(item[nameFields[k]]);
			}
		}
		return names.join(" / ");
	} else {
		if (item[nameFields[0]]) {
			return item[nameFields[0]];
		} else {
			return "-";
		}
	}
}
